import { Country } from '~/Api/Country';

export const formatCountriesError = (countries: Country[]): string =>
	countries.length > 0
		? `, please check products from countries: ${countries.map((country) => country.name).join(', ')}`
		: '';
